/**
 * @description 网络请求管理
 */
import FJCoreUtil from "../core/util/FJCoreUtil";
import FJViewConstant from '../constant/FJViewConstant'
import $ from 'jquery'
import FJUtil from "../util/FJUtil";
import FJCanvasStore from "./FJCanvasStore";
import FJUnsplashStore from "./FJUnsplashStore";
import FJConfig from "../config/FJConfig";
import FJErrorConstant from "../constant/FJErrorConstant";
import FJCoreConstant from "../core/constant/FJCoreConstant";
import AWS from "aws-sdk"

const saveUrl = '/project/save';
const updateUrl = '/project/update';
const loadUrl = '';
const timeOutValue = 60000;
const storyBlockURL = process.env.SERVE_ENV === "release" ? "/stock/" : "https://www.smartvideomaker.com/stock/";
const ajaxGetter = function (options) {
  let {url, success, error, complete} = options;
  try {
    $.ajax(url, {
      success: success ? success : () => {
      },
      error: error ? error : () => {
      },
      complete: complete ? complete : () => {
      },
    });
  } catch (e) {
    if (error) {
      error();
    }
  }
};
const ajaxPoster = function (options) {
  let {url, data, success, error, complete} = options;
  try {
    let r = $.ajax(url, {
      type: 'POST',
      data: data,
      success: success ? success : () => {
      },
      error: error ? error : () => {
      },
      complete: complete ? complete : () => {
      },
    });
    return r;
  } catch (e) {
    if (error) {
      error();
    }
  }

};
const collectUserSearchKeywords = function (data) {
  let postData = {};
  let curTime = Date.now();
  let {type, keywords} = data;
  let {uid = '001'} = window;
  const {VIDEO, IMAGE, AUDIO} = FJCoreConstant;
  switch (type) {
    case VIDEO:
      type = postData.type = 'video';
      break;
    case IMAGE:
      type = postData.type = 'photo';
      break;
    case AUDIO:
      type = postData.type = 'audio';
      break;
    default:

      // 传入数据不正常，结束调用
      return;
  }
  postData.keywords = keywords;
  let localData = JSON.parse(FJUtil.localStorageFunc('userSearchData'));
  if (localData && localData[uid] && localData[uid][type] && localData[uid][type].length !== 0) {
    let curData = localData[uid][type].find((item) => {

      return item.keywords === keywords;
    });
    if (curData) {
      if (curTime - curData.time > 24 * 60 * 60 * 1000) {

        curData.time = curTime;
      } else {

        // 该用户搜索词未超过24小时，结束调用
        return;
      }
    } else {

      localData[uid][type].push({keywords: keywords, time: curTime});
    }
  } else {
    localData = localData || {};
    localData[uid] = localData[uid] || {};
    localData[uid][type] = [{keywords: keywords, time: curTime}];
  }
  FJUtil.localStorageFunc('userSearchData', JSON.stringify(localData));

  // 请求后台
  ajaxPoster({
    url: '/stock/record-search-keyword',
    data: {
      keyword: postData.keywords,
      media_type: postData.type
    },
    success: (res) => {
    }
  });
};
const getProjectId = function () {
  return process.env.SERVE_ENV === "release" ? FJCanvasStore.executeSync(FJCanvasStore.command.GET_PROJECT_ID)
    : '123';
};

function timeout(ms, promise) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      reject(new Error("timeout"))
    }, ms);
    promise.then(resolve, reject)
  })
}


let uploadCloudMediaInfoAjax = null;
let checkMediaWhenCloudAjax = null;
let uploadAjax = null;

let FJNetworkStore = (function () {

  let isTest = "www.flexclip.com" !== document.domain;
  let albumBucketName = isTest ? "flexclip-test" : "flexclip-media";
  let bucketRegion = isTest ? "us-west-1" : "us-west-2";
  let IdentityPoolId = isTest ? "us-west-1:c5f35c2f-1ccf-4e23-8172-23fbb58415a5" : "us-west-2:fcddaf98-e358-431a-a47f-6bdabd7b263d";

  AWS.config.update({
    region: bucketRegion,
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: IdentityPoolId
    })
  });

  let s3 = new AWS.S3({
    apiVersion: "2006-03-01",
    params: { Bucket: albumBucketName }
  });

  return {

    /**
     * @description 获取本地化语言
     * @param path
     * @return {Promise<Object>}
     */
    initLanguage: function (path) {
      return new Promise((resolve, reject) => {
        FJCoreUtil.fetchJson(path)
          .then(data => resolve(data))
          .catch(reject);
      });
    },

    /**
     * @description 保存工程
     * @param id
     * @param blob
     * @return {Promise<unknown>}
     */
    saveProject: function (id, blob) {
      return new Promise((resolve, reject) => {
        let file = new window.File([blob], 'saveData.zip', {type: 'application/zip'});
        let fd = new FormData();
        fd.append('id', id);
        fd.append('file', file);
        fd.append('type', 'timeline');
        timeout(timeOutValue, fetch(saveUrl, {
          body: fd,
          cache: 'no-cache',
          method: 'POST',
        }).then(res => res.json())
          .then(response => {
            if (response.code === 200) {
              resolve(response);
            } else {
              reject(new Error(response.code));
            }
          }).catch(reject)).catch(reject);
      })
    },

    /**
     * @description 加载工程
     * @param id
     * @return {Promise<unknown>}
     */
    loadProject: function (id) {
      return new Promise((resolve, reject) => {
        timeout(timeOutValue, fetch(loadUrl, {
          body: {id},
          cache: 'no-cache',
          method: 'GET',
        }).then(res => res.json())
          .then(response => {
            if (response.code === 200) {
              resolve(response.data);
            } else {
              reject(new Error('LOAD FAIL'));
            }
          }).catch(reject)).catch(reject)
      })
    },

    /**
     * @description 更新工程数据
     * @param id
     * @param data
     * @return {Promise<unknown>}
     */
    updateProject: function (id, data) {
      return new Promise(((resolve, reject) => {
        let url = updateUrl;
        let formData = new FormData();
        formData.append('id', id);
        formData.append('type', 'timeline');
        formData.append('data', JSON.stringify(data));
        timeout(timeOutValue, fetch(url, {
          cache: 'no-cache',
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          body: formData,
        }).then((response) => {
          return response.json();
        }).then((json) => {
          if (json.code === 200) {
            resolve();
          } else {
            reject(new Error(json));
          }
        }).catch(reject)).catch(reject);
      }))
    },

    /**
     * @description 获取资源
     * @param url
     * @param type
     * @param options
     * @param options.success
     * @param options.error
     * @param options.progress
     * @param options.abort
     */
    fetchResource: function (url, type, options = {}) {
      let {success, error, progress, abort} = options;
      let xhr = new XMLHttpRequest();
      xhr.open(options.method || 'GET', url, true);
      xhr.responseType = type || 'json';
      xhr.onload = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          if (success) {
            success(xhr.response);
          }
        } else if (error) {
          error(xhr);
        }
      };
      xhr.onerror = error || (() => {
      });
      xhr.onabort = abort || (() => {
      });
      xhr.onprogress = (e) => {
        try {
          let value = e.lengthComputable ? e.loaded / e.total : e.loaded / (1024 * 1024 * 3);
          value = value > 1 ? 1 : value;
          if (progress) {
            progress(value);
          }
        } catch (e) {
          console.log("onprogress error");
        }
      };
      xhr.onreadystatechange = (e) => {
        if (xhr.status === 0 && xhr.readyState === 4 && error) {
          error(e);
        }
      };
      xhr.send();
      return () => {
        xhr.abort();
      };
    },

    /**
     * @description 异步获取资源
     * @param url
     * @param type
     * @return {Promise<unknown>}
     */
    fetchResourceAsync: function (url, type) {
      return new Promise((resolve, reject) => {
        this.fetchResource(url, type, {
          success: resolve,
          error: reject,
        })
      });
    },

    /**
     * @description 搜索第三方媒体资源
     * @param data
     */
    searchMedias: function (data) {
      return new Promise((resolve, reject) => {
        const {VIDEO, IMAGE, AUDIO} = FJCoreConstant;
        const pageNumber = 30;
        let {type, sortType, keywords, page, numResults, categories, genres, moods, instruments, durationRange} = data;
        switch (type) {
          case VIDEO:
          case AUDIO: {
            numResults = numResults || pageNumber;
            let sort = '';
            switch (sortType) {
              case FJViewConstant.SORT_TYPE_RELEVANT:
                sort = 'most_relevant';
                break;
              case FJViewConstant.SORT_TYPE_DOWNLOADED:
                sort = 'most_downloaded';
                break;
              case FJViewConstant.SORT_TYPE_UNDISCOVERED:
                sort = 'undiscovered';
                break;
              case FJViewConstant.SORT_TYPE_RESENT:
                sort = 'most_recent';
                break;
              case FJViewConstant.SORT_TYPE_RATED:
                sort = 'highest_rated';
                break;
              case FJViewConstant.SORT_TYPE_TRENDING:
                sort = 'trending_now';
                break;
              default:
                sort = 'most_relevant';
            }
            let url = storyBlockURL + (type === VIDEO ? "search-video" : "search-audio");
            let minDuration = 1;
            let maxDuration = 1000;
            if (durationRange) {
              minDuration = durationRange[0];
              maxDuration = durationRange[1] === 240 ? maxDuration : durationRange[1];
            }

            if (maxDuration === 0 && maxDuration === 0) {
              resolve([[], 0]);
            } else {
              ajaxPoster({
                url: url,
                data: {
                  keywords: keywords,
                  page: page,
                  categories: categories ? categories : '',
                  genres: genres,
                  moods: moods,
                  instruments: instruments,
                  numResults: numResults,
                  sort: sort,
                  minDuration: minDuration,
                  maxDuration: maxDuration,
                  user_id: FJUtil.getUerId(),
                  project_id: getProjectId(),
                  contentType: type === VIDEO ? 'footage,motionbackgrounds' : '' // 音频contentTYPE由后端决定，有标签为music无则为all
                },
                success: (response) => {
                  if (response.json && response.json.results) {
                    let results = response.json.results;
                    let totalSearchResults = response.json.total_results;
                    if (page === 1 && totalSearchResults < pageNumber) {
                      totalSearchResults = results.length;
                    }

                    /**
                     * 为了兼容v1接口，这里对数据进行预处理，尽可能组成出以前的属性
                     * @param results
                     * @returns {*}
                     * @private
                     */
                    const __handleResults = (results) => {
                      if (data.type === VIDEO) {
                        const sizeList = ['_180p', '_360p', '_480p', '_720p', '_1080p'];
                        return results.map(item => {
                          let preview_url_small = null;
                          if (item.preview_urls) {
                            for (let i = 0; i < sizeList.length; ++i) {
                              if (item.preview_urls[sizeList[i]]) {
                                preview_url_small = item.preview_urls[sizeList[i]];
                                break;
                              }
                            }
                          }

                          return {
                            ...item,
                            preview_url_small,
                            preview_url: preview_url_small,
                          };
                        });
                      } else {
                        return results.map(item => {
                          return {
                            ...item,
                          }
                        })
                      }
                    };
                    results = __handleResults(results);

                    if (totalSearchResults > 0) {
                      collectUserSearchKeywords(data);
                    }

                    resolve([results, totalSearchResults]);
                  } else {
                    reject(response);
                  }
                },
                error: reject,
              });
            }

            break;
          }
          case IMAGE: {
            page = data.page || 1;
            numResults = data.numResults || pageNumber;
            FJUnsplashStore.search(keywords, page, numResults, (json) => {
              if (json.total > 0) {
                collectUserSearchKeywords(data);
              }
              resolve([json.results, json.total]);
            }, reject);
            break;
          }
          default:
            reject(new Error(FJErrorConstant.ERR_ARGUMENTS));
            break;
        }
      })
    },

    /**
     * @description 获取第三方媒体
     * @param data
     */
    getMedia: function (data) {
      return new Promise((resolve, reject) => {
        const {VIDEO, IMAGE, AUDIO} = FJCoreConstant;
        switch (data.type) {
          case VIDEO:
          case AUDIO: {
            let {id} = data;
            let url = storyBlockURL + (data.type === VIDEO ? "get-video" : "get-audio");
            ajaxPoster({
              url: url,
              data: {
                id: id,
              },
              success: (data) => {
                if (data.json && !data.json.errors) {
                  resolve(data.json);
                } else {
                  reject(data);
                }
              },
              error: reject,
            });
            break;
          }
          case IMAGE: {
            let {id} = data;
            FJUnsplashStore.getPhoto(id).then(resolve).catch(reject);
            break;
          }
          default:
            reject(new Error(FJErrorConstant.ERR_ARGUMENTS));
            break;
        }
      })
    },

    /**
     * @description 返回第三方媒体的真实下载路径
     * @param data
     * @param data.id
     * @param data.type
     */
    downloadMedia: function (data) {
      return new Promise((resolve, reject) => {
        const {VIDEO, AUDIO} = FJCoreConstant;
        switch (data.type) {
          case VIDEO:
          case AUDIO: {
            let {id, type} = data;
            let url = storyBlockURL + (type === VIDEO ? "download-video" : "download-audio");
            ajaxPoster({
              url: url,
              data: {
                id: id,
                user_id: FJUtil.getUerId(),
                project_id: getProjectId(),
              },
              success: (data) => {
                if (data.json && !data.error) {
                  if (type === VIDEO) {
                    let urls = data.json.MP4 || {};
                    let qList = ['_1080p', '_720p', '_2160p'];
                    Object.keys(data.json).forEach((format) => {
                      if (format !== 'MP4') {
                        qList.forEach(item => {
                          if (!urls[item]) {
                            urls[item] = data.json[format][item];
                          }
                        });
                      }
                    });

                    // 优先使用1080p
                    data.json.url = urls['_1080p'] || urls['_720p'] || urls['_2160p'];
                  } else {
                    data.json.url = data.json['MP3'] || data.json['WAV'];
                  }

                  resolve(data.json.url);
                } else {
                  reject(data);
                }
              },
              error: reject,
            });
            break;
          }
          default:
            reject(new Error(FJErrorConstant.ERR_ARGUMENTS));
            break;
        }
      })
    },

    /**
     * @description 获取第三方媒体集合
     * @param data
     */
    getMediaCollections: function (data) {
      return new Promise((resolve, reject) => {
        const {videoCollectionsPath, audioCollectionsPath} = FJConfig;
        const {VIDEO, AUDIO} = FJCoreConstant;
        switch (data.type) {
          case VIDEO:
          case AUDIO: {
            let url = (data.type === VIDEO ?
              videoCollectionsPath : audioCollectionsPath);
            ajaxGetter({
              url: url,
              success: resolve,
              error: reject,
            });
            break;
          }
        }
      })
    },

    /**
     * @description 获取第三方媒体集合数据
     * @param data
     */
    getMediaCollectionItems: function (data) {
      return new Promise((resolve, reject) => {
        const {VIDEO, AUDIO} = FJCoreConstant;
        switch (data.type) {
          case VIDEO:
          case AUDIO: {
            let {id, page = 1, numResults = 9999} = data;
            let url = storyBlockURL + (data.type === VIDEO ? "video-collection" : "audio-collection");
            ajaxPoster({
              url: url,
              data: {
                id: id,
                page: page,
                numResults: numResults,
              },
              success: (response) => {
                if (response.json && !response.json.erros) {
                  let results = response.json;
                  resolve(results);
                } else {
                  reject(response);
                }
              },
              error: reject,
            });
            break;
          }
          default:
            reject(new Error(FJErrorConstant.ERR_ARGUMENTS));
            break;
        }
      })
    },

    /**
     * @description 检查用户账户等级
     * @param success
     * @param error
     */
    checkUserPaymentLevel(success, error) {

      // {"code":200,"msg":"","data":{"result":true,"package":""}}
      // package: '', 'basic', 'plus'
      let data = {};
      if (window.csrf_token) {
        data[window.csrf_token] = 1;
      }
      ajaxPoster({
        url: '/subscription/get_user_package',
        data: data,
        success: success,
        error: error,
      })
    },

    /**
     * @description 同步媒体资源之前进行check
     * @param data
     * @returns {Promise<unknown>}
     */
    checkMediaWhenCloudSync (data) {
      return new Promise(((resolve, reject) => {
        if (window.csrf_token) data[window.csrf_token] = 1;
        checkMediaWhenCloudAjax = ajaxPoster({
          url: (process.env.SERVE_ENV === 'local') ? 'https://www.smartvideomaker.com/cloud/media/check' : '/cloud/media/check',
          data: data,
          success: (response) => {
            checkMediaWhenCloudAjax = null;
            resolve(response.code);
          },
          error: (error) => {
            checkMediaWhenCloudAjax = null;
            reject(error);
          },
        });
      }))
    },

    /**
     * @description 同步媒体资源到s3后同步信息到自己服务器 更新云端数据库
     * @param data
     * @returns {Promise<unknown>}
     */
    uploadCloudMediaInfo (data) {
      return new Promise(((resolve, reject) => {
        if (window.csrf_token) data[window.csrf_token] = 1;
        uploadCloudMediaInfoAjax = ajaxPoster({
          url: (process.env.SERVE_ENV === 'local') ? 'https://www.smartvideomaker.com/cloud/media/upload' : '/cloud/media/upload',
          data: data,
          success: (response) => {
            uploadCloudMediaInfoAjax = null;
            resolve(response.code);
          },
          error: (error) => {
            uploadCloudMediaInfoAjax = null;
            reject(error);
          },
        });
      }))
    },

    /**
     * 上传媒体素材
     * @param file
     * @param key
     * @param callback
     */
    uploadToS3(file, key, callback) {
      this._s3UploadMedia(file, key, callback);
    },

    /**
     * s3上传
     * @param file
     * @param key
     * @param callback
     * @private
     */
    _s3UploadMedia(file, key, callback) {
      if(!file || !key)
        return;

      let contentType = "application/octet-stream";
      let ext = FJUtil.getPathSuffix(key);
      if(ext === "svg")
        contentType = "image/svg+xml";

      // Use S3 ManagedUpload class as it supports multipart uploads
      uploadAjax = new AWS.S3.ManagedUpload({
        params: {
          Bucket: albumBucketName,
          Key: key,
          Body: file,
          ACL: "public-read",
          ContentType: contentType
        }
      });

      uploadAjax.on("httpUploadProgress", (progress) => {
        if(callback)
          callback({type: "progress", data:progress});
      });

      let promise = uploadAjax.promise();
      promise.then(
          (data) => {
            uploadAjax =null;
            if(callback)
              callback({type: "done", data:data});
          },
          function(err) {
            uploadAjax =null;
            if(callback)
              callback({type: "error", msg:"There was an error uploading your photo: " + err.message});
          }
      );
    },

    /**
     * 删除媒体素材
     * @param media
     * @param callback
     */
    deleteS3Media(media, callback)
    {
      this._s3DeleteMedia(FJUtil.getS3Key(media), callback);
      this._s3DeleteMedia(FJUtil.getS3CoverKey(media), callback);
    },

    /**
     * s3删除
     * @param key
     * @param callback
     * @private
     */
    _s3DeleteMedia(key, callback) {
      if(!key)
        return;

      s3.deleteObject({ Key: key }, function(err, data) {
        if (err) {
          if(callback)
            callback({type: "error", msg:"There was an error deleting your photo: " + err.message});
        }
        else
        {
          if(callback)
            callback({type: "done"});
        }
      });
    },

    /**
     * @description 删除服务器的 云空间资源的资源信息
     * @param mediaId 媒体id
     * @returns {Promise<unknown>}
     */
    deleteCloudResourceById (mediaId) {
      return new Promise(((resolve, reject) => {
        let data = {
          key: mediaId,
        };
        if (window.csrf_token) data[window.csrf_token] = 1;
        ajaxPoster({
          url: (process.env.SERVE_ENV === 'local') ? 'https://www.smartvideomaker.com/cloud/media/delete' : '/cloud/media/delete',
          data,
          success: (response) => {
            if (response && response.code === 200) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            reject(error);
          },
        });
      }))
    },


    /**
     * @description 终止上传media到云空间
     * @param media
     */
    stopUploadMedia (media) {
      if (checkMediaWhenCloudAjax) {
        checkMediaWhenCloudAjax.abort()
        checkMediaWhenCloudAjax = null;
      }

      if (uploadAjax) {
        uploadAjax.abort();
        uploadAjax = null;
      }

      if (uploadCloudMediaInfoAjax) {
        uploadCloudMediaInfoAjax.abort();
        uploadCloudMediaInfoAjax = null
      }

      this.deleteS3Media(media);
      this.deleteCloudResourceById(media.id);
    },

    /**
     * @description 获取云空间大小的接口
     * @returns {Promise<unknown>}
     */
    getCloudSpace () {
      return new Promise(((resolve, reject) => {
        ajaxGetter({
          url: (process.env.SERVE_ENV === 'local') ? 'https://www.smartvideomaker.com/cloud/space/usage' : '/cloud/space/usage',
          success: (response) => {
            if (response && response.code === 200) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: () => {
            reject(new Error('error in getCloudSpace!'));
          },
        });
      }))
    }

  }
})();

export default FJNetworkStore;
